import { Module } from 'vuex'
import { RootState } from '@/store/types'
import { MailTemplatesState } from '@/store/mails/templates/types'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const MailTemplates: Module<MailTemplatesState, RootState> = {
  state: () => ({
    templates: [],
    pager: {
      current: 1,
      last: 1,
      totalLength: 0,
    },
  }),
  mutations,
  actions,
  getters,
}

export default MailTemplates
